/* eslint-disable consistent-return */
/* eslint-disable class-methods-use-this */
import { deviceButtonTitle } from 'constants/device';
// import { LOCAL_STORAGE_DATA_KEY } from 'store/ProductCatalog/outofstock/constants';
// import getLocalCurrencyStr from 'utils/getLocalCurrencyStr';

class DeviceMapper {
  getDeviceMappedBadges(badges) {
    return badges.reduce((acc, cur) => {
      let badge = {
        children: cur.title,
        help: cur.content,
      };

      if (cur.variant) {
        badge = {
          ...badge,
          variant: cur.variant,
        };
      }

      if (cur.textColor) {
        badge = {
          ...badge,
          textColor: cur.textColor,
        };
      }

      acc.push(badge);
      return acc;
    }, []);
  }

  getDeviceMappedClides(slides) {
    return slides.map((slide) => ({
      src: slide.imageUrl,
      alt: slide.alt,
    }));
  }

  getDeviceMappedColors(colors) {
    return colors.map((color) => ({
      value: color.href,
      label: color.color,
      isActive: color.isActive,
    }));
  }

  getDeviceMappedCapacity(capacity) {
    if (capacity) {
      return capacity.map((item) => ({
        value: item.href,
        label: item.title,
        isActive: item.isActive,
      }));
    }
  }

  getButtonText(isInBasket, isPreorder) {
    if (isInBasket) {
      return deviceButtonTitle.IN_BASKET;
    }

    if (isPreorder) {
      return deviceButtonTitle.PRE_ORDER;
    }

    return deviceButtonTitle.TO_BASKET;
  }
}

export const deviceMapper = new DeviceMapper();
